import { Component, EventEmitter, OnInit, Output } from '@angular/core';

import {
  MaintenanceCycle,
  SmartAssetRecommendation,
  SmartAssetRecommendationResults,
} from 'src/app/layout/models/smart-asset-recommendation';
import { BottomConfirmationMessageComponent } from 'src/app/shared/components/bottom-confirmation-message/bottom-confirmation-message.component';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { JobService } from 'src/app/core/services/http/maintenance/job.service';
import { forkJoin, map, of, switchMap, tap } from 'rxjs';
import { JobTradeService } from 'src/app/core/services/http/maintenance/job-trade.service';
import { JobPostRequest } from 'src/app/job/models/job-post/job-post-request.model';
import {
  AssignTradeOptions,
  AssignTradeRequest,
} from 'src/app/job/models/job-post/assign-trade-request.model';
import { TosterService } from 'src/app/core/services/toster/toster.service';
import { Asset, Job, Payer } from 'src/app/job/models/job-post/job.model';
import { PropertyService } from '../../../../core/services/http/agency-mgmt/property.service';
import { Tenant } from 'src/app/job/models/job-detail/invoice/tenancy-invoice-request.model';
import { TenantService } from 'src/app/core/services/http/agency-mgmt/tenant.service';
import {
  JobBudgetOptions,
  JobPriority
} from 'src/app/job/constants/job-post/job-post.enums';
import { PredictiveDataService } from 'src/app/core/services/http/maintenance/predictive-data.service';
import { JobPostDataService } from 'src/app/job/services/job-post-data.service';
import { SettingsService } from 'src/app/core/services/http/agency-mgmt/settings.service';
import { AssetService } from 'src/app/core/services/http/agency-mgmt/asset.service';

@Component({
  selector: 'app-asset-recommendations',
  templateUrl: './asset-recommendations.component.html',
  styleUrls: ['./asset-recommendations.component.scss'],
})
export class AssetRecommendationsComponent implements OnInit {
  @Output() closeEvent = new EventEmitter();

  assetsDetails: SmartAssetRecommendationResults =
    new SmartAssetRecommendationResults();
  isAssetListLoading: boolean;
  pageSize: number = 5;
  pageNumber: number = 0;
  pageTotal: number = 0;
  isSavingDraft = false;
  job = Job.getInstance();
  tenants: Tenant[];
  selectedAsset: SmartAssetRecommendation;
  isOpenAssetDetailsDrawer: boolean = false;
  isOpenAssetSnoozedDrawer: boolean = false;
  selectedAssetId: string = '';
  maintenanceCycleForselectedAsset: string = '';
  titleForselectedAsset: string = '';
  isEnabledBudgetPreselectedOption: boolean;
  isProcessing: boolean = false;

  constructor(
    private bottomSheet: MatBottomSheet,
    private jobSvc: JobService,
    private jobTradeSvc: JobTradeService,
    private tosterService: TosterService,
    private propertySvc: PropertyService,
    private tenantSvc: TenantService,
    private predictiveDataSvc: PredictiveDataService,
    private dataService: JobPostDataService,
    private settingsService: SettingsService,
    private assetService: AssetService
  ) {}

  ngOnInit(): void {
    this.getGeneralSettings();
    this.getAssets();
  }

  public dismiss() {
    Job.distroyObj();
    this.closeEvent.emit();
  }

  getGeneralSettings() {
    this.settingsService.generalSettings$ = null;
    this.settingsService.generalSettings().subscribe((data) => {
      this.isEnabledBudgetPreselectedOption =
        data.isEnabledBudgetPreselectedOption;
    });
  }

  getAssetsPaginatedResult(event: any) {
    this.pageNumber = event;
    this.getAssets();
  }

  getAssets() {
    this.isAssetListLoading = true;
    this.assetService
      .getJobAssetRecommendations(this.pageNumber)
      .subscribe((res) => {
        this.assetsDetails = {
          assets: res.assets,
          pageTotal: res.pageTotal,
        };
        this.pageTotal = res.pageTotal; 
        this.isAssetListLoading = false;
        this.isProcessing = false;
      });
  }

  rejectRecomandation(asset: SmartAssetRecommendation) {
    const bottomSheetRef = this.bottomSheet.open(
      BottomConfirmationMessageComponent,
      {
        data: {
          message: 'Are you sure you want to reject the recommendation?'
        },
      }
    );

    bottomSheetRef.afterDismissed().subscribe((response) => {
      if (response === true) {
        this.isProcessing = true;
        asset.isRejected = true;
        asset.isRead = true;
        this.changeStatus(asset);
      }
    });
  }

  changeStatus(asset: SmartAssetRecommendation) {
    this.assetService.changeRecommendationStatus(asset).subscribe({
      next: () => {
        if(asset.isRejected){
        this.tosterService.success('Recommendation rejected successfully');
        }
        this.getAssets();
      },
    });
  }

  acceptRecomandation(asset: SmartAssetRecommendation) {
    this.selectedAsset = asset;
    this.isSavingDraft = true;
    const bottomSheetRef = this.bottomSheet.open(
      BottomConfirmationMessageComponent,
      {
        data: {
          message:
            'Are you sure you want to post a job for this recommendation? Please confirm to proceed or cancel to review the details',
          isInviteTenant: true,
        },
      }
    );

    bottomSheetRef.afterDismissed().subscribe((response) => {
      if (response === true) {
        this.isProcessing = true;
        this.getByPropertyDetails();
      }
    });
  }

  private getByPropertyDetails() {
    if (!this.selectedAsset.propertyId) {
      this.isProcessing = false;
      this.tosterService.success('No assign property found');
      return;
    }
   this.job = Job.getInstance();
    this.propertySvc.getByPropertyId(this.selectedAsset.propertyId).subscribe({
      next: (res) => {
        this.job.property = res;
        if (this.job.property) {
          this.mapAndDraftJob();
        }
      },
    });
  }

  jobPostAsDraft() {
    this.jobSvc
      .jobPost(new JobPostRequest(this.job, true))
      .pipe(
        tap((res) => {
          AssignTradeOptions.getInstance().jobId = res.id;
        }),
        switchMap((res) =>
          this.jobTradeSvc
            .update(
              new AssignTradeRequest(
                AssignTradeOptions.getInstance(),
                this.job.tradeNote?.text,
                this.job.isOwnerAttending,
                this.job.isHideTenantDetailsToOwner
              )
            )
            .pipe(
              map(() => {
                return res;
              })
            )
        )
      )
      .subscribe({
        next: (result: any) => {
          if (result?.id) {
            if (this.job.payer?.id && this.job.payerChanged) {
              this.changePayerIfChanged(result.id).subscribe({
                next: () => {
                  this.jobDraftSuccess();
                },
                error: () => {
                  this.isProcessing = false;
                  this.isSavingDraft = false;
                },
              });
            } else {
              this.jobDraftSuccess();
            }
          }
        },
        error: () => {
          this.isProcessing = false;
          this.isSavingDraft = false;
        },
      });
  }

  private changePayerIfChanged(jobId: string = null) {
    if (!this.job.payerChanged) return of('payer not changed');

    return this.jobSvc.changePayer({
      id: jobId != null ? jobId : this.job.id,
      payerId: this.job.payer.id,
      payerType: this.job.payer.type,
      initialPayment: 0,
      externalPayerEmail: this.job.payer.email,
    });
  }

  jobDraftSuccess() {
    Job.distroyObj();
    this.getAssets();
    this.tosterService.success(
      'A draft job has been successfully created for this recommendation'
    );
  }

  mapAndDraftJob(): void {
    this.job.title = this.selectedAsset.assetName + ' Maintenance';
    this.job.description =
      'The ' +
      this.selectedAsset.assetName +
      ' needs to be repaired ' +
      this.getAssetMaintainanceType(this.selectedAsset.maintenanceCycle);
    this.fetchPropertyUsersDetail();
    const data$ = forkJoin({
      predictiveData: this.predictiveDataSvc.getJobTypes(
        this.job.title,
        this.job.description
      ),
      jobBudget: this.dataService.getBudget(
        this.job.title,
        this.job.description
      ),
      jobPriority: this.dataService.getUrgency(),
      assetDetails: this.assetService.getById(this.selectedAsset.assetId),
    });
    data$.subscribe({
      next: (res) => {
        this.mapJobType(res.predictiveData);
        this.mapPriority(res.jobPriority);
        this.job.budget = res.jobBudget;
        if (!this.isEnabledBudgetPreselectedOption) {
          this.job.budget.option = JobBudgetOptions.Under500;
        }
        this.job.canShowRelatedJobsDrawer = false;
        this.job.isFromAssetRecommendations = true;
        this.job.assetRecommendationId = this.selectedAsset.id;
        this.job.assets.push(res.assetDetails);    
        this.jobPostAsDraft();
      },
    });
  }

  fetchPropertyUsersDetail(): void {
    this.getTenants();
    this.updatePropertyUsers();
  }

  getTenants() {
    this.tenantSvc
      .getTenantSelectionOptions(this.selectedAsset.propertyId)
      .subscribe({
        next: (res) => {
          this.tenants = res.filter(
            (tenant) => tenant.isActive && tenant.activationStatus != 7
          );
          this.setDefaultTenant();
        },
      });
  }

  setDefaultTenant() {
    let primaryTenant = this.tenants?.find((t) => t.isPrimary);
    if (primaryTenant) {
      this.job.tenant = JSON.parse(JSON.stringify(primaryTenant));
    } else {
      this.job.tenant = this.tenants[0]
        ? JSON.parse(JSON.stringify(this.tenants[0]))
        : null;
    }
  }

  updatePropertyUsers() {
    this.propertySvc
      .getPropertyUsersByPropertyId(this.job.property.id)
      .subscribe({
        next: (res) => {
          this.job.owners = res.owners;
          this.job.assignPms = res.assignPms;
          this.job.payer = res.payer;
          this.job.defaultPayer = res.payer;
          this.job.property.maintenanceNote = res.property.maintenanceNote;
          this.job.property.hasStrataDetails = res.property.hasStrataDetails;
          this.job.jobWarningNotes = res.property.warningNotes?.join(', ');
          this.job.property.ownerThreshold = res.property.ownerThreshold;
        },
      });
  }

  mapJobType(res: any) {
    if (res.primaryJobType) this.job.primaryJobType = res.primaryJobType;
    if (res.secondaryJobType) this.job.secondaryJobType = res.secondaryJobType;
  }

  mapPriority(priority: JobPriority) {
    if (!priority) priority = JobPriority.Normal;
    if (this.job.isUrgencyPriorityChange || this.isDueDateChanged()) return;
    this.job.priority.type = priority;
    this.job.priority.dueDate = new Date();
    if (priority == JobPriority.Emergency) {
      this.job.priority.dueDate.setDate(this.job.priority.dueDate.getDate());
    } else if (priority == JobPriority.Urgent) {
      this.job.priority.dueDate.setDate(
        this.job.priority.dueDate.getDate() + 3
      );
    } else if (priority == JobPriority.Normal) {
      this.job.priority.dueDate.setDate(
        this.job.priority.dueDate.getDate() + 7
      );
    }
  }
  isDueDateChanged(): boolean {
    let currentDate = new Date();
    let jobPriority = this.job.priority.type;
    let jobDueDate = this.job.priority.dueDate.getDate();
    if (
      jobPriority == JobPriority.Urgent &&
      jobDueDate !=
        new Date(currentDate.setDate(currentDate.getDate() + 3)).getDate()
    )
      return true;
    else if (
      jobPriority == JobPriority.Emergency &&
      jobDueDate != currentDate.getDate()
    )
      return true;
    else if (
      jobPriority == JobPriority.Normal &&
      jobDueDate !=
        new Date(currentDate.setDate(currentDate.getDate() + 7)).getDate()
    )
      return true;

    return false;
  }

  showAssetDetailDrawer(asset: SmartAssetRecommendation): void {
    this.isOpenAssetDetailsDrawer = true;
    this.selectedAsset = asset;
    this.selectedAssetId = asset.assetId;
    if(!asset.isRead){
    asset.isRead = true;
    this.changeStatus(asset);
    }
  }
  showAssetSnoozedDrawer(asset: SmartAssetRecommendation): void {
    this.isOpenAssetSnoozedDrawer = true;
    this.selectedAsset = asset;
  }
  closeAssetDetailDrawer(): void {
    this.isOpenAssetDetailsDrawer = false;
  }

  closeDrawer(): void {
    this.isOpenAssetDetailsDrawer = false;
    this.isOpenAssetSnoozedDrawer = false;
  }

  getAssetMaintainanceType(assetCycle: MaintenanceCycle): string {
    switch (assetCycle) {
      case MaintenanceCycle.LessThanWeek:
        return 'before 4 days';
      case MaintenanceCycle.InMonth:
        return 'before 2 weeks';
      case MaintenanceCycle.InThreeMonths:
        return 'before 1 month';
      case MaintenanceCycle.InSixMonths:
        return 'before 3 months';
      case MaintenanceCycle.InYear:
        return '6 months before';
      case MaintenanceCycle.WithinTwoYears:
        return '6 months before';
    }
    return 'Not considered';
  }

  refreshRecomendation(){
    this.isProcessing = true;
   this.getAssets();
  }

  acceptRecomandationFromAssetView(){
    this.isOpenAssetDetailsDrawer = false;
    this.acceptRecomandation(this.selectedAsset);
  }

  rejectRecomandationFromAssetView(){
    this.isOpenAssetDetailsDrawer = false;
    this.rejectRecomandation(this.selectedAsset);
  }

  snoozeRecomandationFromAssetView(){
    this.isOpenAssetDetailsDrawer = false;
    this.showAssetSnoozedDrawer(this.selectedAsset);
  }
}
